import React from "react";
import { Row, Col, Button, Alert } from "react-bootstrap";
import ReactSelect from "react-select";
import { connect } from "react-redux";
import { Form} from "formik";
import {
  putDependencytasksAction,
  deleteDependencytasksAction
} from "./../../../actions/PathwayActions";
import moment from "moment";

import downIcon from "./../../../assets/img/down.png";
import upIcon from "./../../../assets/img/up.png";
import nutralIcon from "./../../../assets/img/nutral-icon.png";
import { cryptoTokenDecode, getTimeFromMins } from './../../Common/Common'

var _ = require("lodash");

class SetDependency extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      optionlist: [],
      fromTransaction: false,
      showLoader: true,
      statusMessage: "",
      status: false,
      shortOrder: "",
      menuOpen: false,
      oldvalues: []
    };
  }

  handleChange = values => {
    this.setState({ values });
  };

  /**
   *@desc add new depencies/ update /delete existing dependencies api call
   */
  addDependencies() {
    let selectedTasks = [];
    selectedTasks = this.state.values
      ? this.state.values.map(obj => obj.value)
      : [];
    let oldvalues = this.state.oldvalues
      ? this.state.oldvalues.map(obj => obj.value)
      : [];

    let apidata = {
      predecessor: selectedTasks
    };

    if (JSON.stringify(selectedTasks) !== JSON.stringify(oldvalues)) {
      apidata = {
        predecessor: selectedTasks,
        valueChanged: "dependencies"
      };
    }

    if (
      this.state.btnName.toUpperCase() == "ADD" &&
      selectedTasks.length == 0
    ) {
      setTimeout(
        function() {
          this.props.dependencies(this.state.values);
        }.bind(this),
        100
      );
    } else {
      this.setState({ showLoader: true });
      let eventID = this.props.eventId;
      
      let ROLE = cryptoTokenDecode().usertype;
      if (!this.state.fromTransaction) {
        this.props
          .putDependencytasksAction(eventID, ROLE, apidata)
          .then(res => {
            setTimeout(
              function() {
                this.props.dependencies(this.state.values);
              }.bind(this),
              1000
            );
          });

        if (selectedTasks.length < this.props.predecessors.length) {
          let removeID = [];

          this.props.predecessors.forEach((e, i) => {
            var found = false;
            selectedTasks.forEach((f, i) => {
              if (e._id == f) {
                found = true;
              }
            });
            if (!found) {
              removeID.push(e._id);
            }
          });

          let data = "";
          removeID.forEach((fd, i) => {
            if (i == 0) {
              data += fd;
            } else {
              data += "," + fd;
            }
          });

          this.props.deleteDependencytasksAction(eventID, ROLE, data).then(res => {
            if(!!this.props.statusMessage) {
              this.setState({deleteDependencyMsg : this.props.statusMessage})
            }            
          })
        }
      } else {
        ROLE = "TRANSACTION";
        if (selectedTasks.length < this.props.predecessors.length) {
          let removeID = [];

          this.props.predecessors.forEach((e, i) => {
            var found = false;
            selectedTasks.forEach((f, i) => {
              if (e._id == f) {
                found = true;
              }
            });
            if (!found) {
              removeID.push(e._id);
            }
          });

          let data = "";
          removeID.forEach((fd, i) => {
            if (i == 0) {
              data += fd;
            } else {
              data += "," + fd;
            }
          });

          this.props.deleteDependencytasksAction(eventID, ROLE, data).then(res => {
            if(!!this.props.statusMessage) {
              this.setState({deleteDependencyMsg : this.props.statusMessage})
            }            
          })        }
        this.props
          .putDependencytasksAction(eventID, ROLE, apidata)
          .then(res => {
            setTimeout(
              function() {
                this.props.dependencies(this.state.values);
              }.bind(this),
              1000
            );
          });
      }
    }

    setTimeout(
      function() {
        this.setState({ status: false });
      }.bind(this),
      3000
    );
  }

  /**
   * @desc short dependencies by eventEndDate or time
   * @param {*} list 
   */
  sortDependencies(list) {
    var returnList = [];

    if (list.length > 0) {
      if (list[0] && list[0].hasOwnProperty("eventEndDate")) {
        returnList = _.sortBy(list, "eventEndDate");
      } else {
        returnList = _.sortBy(list, "time");
      }
    }
    return returnList;
  }

  componentDidMount() {
    this.setState({ showLoader: true });
    if (this.props.actiontaken === "UPDATE") {
      if (this.props.predecessors.length > 0) {
        let predecessorArray = this.props.predecessors;

        let predecessorArrayList = predecessorArray.map(obj => {
          if (obj) {
            return {
              label: obj.hasOwnProperty("eventEndDate")
                ? moment(obj.eventEndDate).format("MM-DD-YYYY ") +
                  getTimeFromMins(obj.time) +" " +
                  obj.title
                : "Day" +
                  obj.day +
                  " - " +
                  getTimeFromMins(obj.time) +" "+
                  obj.title,
              value: obj._id,
              day: obj.day,
              title: obj.title
            };
          }
        });
        this.setState({
          oldvalues: this.sortDependencies(predecessorArrayList),
          values: this.sortDependencies(predecessorArrayList),
          showLoader: false
        });
      }
    }
    let arrayss = this.props.options;
    let resultarray = arrayss.map(obj => {
      if (obj) {
        return {
          label: obj.hasOwnProperty("eventEndDate")
            ? moment(obj.eventEndDate).format("MM-DD-YYYY ") +
              getTimeFromMins(obj.time)+" " +
              obj.title
            : "Day" +
              obj.day +
              " - " +
              getTimeFromMins(obj.time) +" "+
              obj.title,
          value: obj._id,
          day: obj.day,
          title: obj.title
        };
      }
    });
    this.setState({
      optionlist: this.sortDependencies(resultarray),
      fromTransaction: this.props.fromTransaction
        ? this.props.fromTransaction
        : false,
      btnName: this.props.actiontaken,
      showLoader: false
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
    this.setState({ showLoader: false });
  }

  sortTasksByTitle(order) {
    this.setState({ menuOpen: true });

    let list = this.state.optionlist;
    var returnList = [];

    if (list.length > 0) {
      returnList = _.orderBy(list, ["title"], [order]);
    }
    this.setState({ shortOrder: order, optionlist: returnList });
  }

  render() {
    return (
      <Form>
        {this.state.showLoader === true && (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        )}
        {this.state.statusMessage != null && this.state.status ? (
          <Alert variant="success">{ !!this.state.deleteDependencyMsg ? this.state.deleteDependencyMsg : this.state.statusMessage}</Alert>
        ) : (
          ""
        )}
        <div className="dependency-select">
          <Row className="align-items-center">
            <Col className="pr-0">
              <ReactSelect
                defaultMenuIsOpen={this.state.menuOpen}
                isClearable={false}
                closeMenuOnSelect={false}
                placeholder=""
                isMulti
                options={this.state.optionlist}
                className="react-select-wrapper react-select-multi"
                onChange={this.handleChange}
                value={this.state.values}
                isDisabled={
                  this.props.fromTransaction
                    ? this.props.transactionData !== undefined &&
                      this.props.transactionData.status !== "COMPLETED"
                      ? false
                      : true
                    : false
                }
              />
            </Col>
            <Col className="col-auto">
              {this.state.shortOrder == "desc" && (
                <Button
                  className="btn-sort w-icn"
                  variant="transparent"
                  onClick={() => {
                    this.sortTasksByTitle("asc");
                  }}
                >
                  <img src={downIcon} alt="sort" />
                </Button>
              )}
              {this.state.shortOrder == "asc" && (
                <Button
                  className="btn-sort w-icn"
                  variant="transparent"
                  onClick={() => {
                    this.sortTasksByTitle("desc");
                  }}
                >
                  <img src={upIcon} alt="sort" />
                </Button>
              )}
              {(this.state.shortOrder == undefined ||
                this.state.shortOrder == "") && (
                <Button
                  className="btn-sort w-icn"
                  variant="transparent"
                  onClick={() => {
                    this.sortTasksByTitle("asc");
                  }}
                >
                  <img src={nutralIcon} alt="sort" />
                </Button>
              )}
            </Col>
          </Row>
        </div>
        {this.props.fromTransaction ? (
          this.props.transactionData !== undefined &&
          this.props.transactionData.status !== "COMPLETED" && (
            <div className="mt-2 text-right">
              <Button
                variant="primary"
                size="sm"
                className="btn-blue"
                onClick={() => this.addDependencies()}
                style={{ width: "85px" }}
              >
                {this.state.btnName}
              </Button>
            </div>
          )
        ) : (
          <div className="mt-2 text-right">
            <Button
              variant="primary"
              size="sm"
              className="btn-blue"
              onClick={() => this.addDependencies()}
              style={{ width: "85px" }}
            >
              {this.state.btnName}
            </Button>
          </div>
        )}
      </Form>
    );
  }
}
const mapStateToProps = state => {
  return {
    statusMessage: state.reducer.statusMessage,
    status: state.reducer.status
  };
};
export default connect(mapStateToProps, {
  putDependencytasksAction,
  deleteDependencytasksAction
})(SetDependency);
